// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3n7Iq{color:#4d4d4d;font-size:18px!important;font-weight:700;margin:35px 0 20px;line-height:30px;direction:rtl}.CYWBC{position:relative}._2PiyJ{color:#4d4d4d;text-align:justify;direction:rtl;position:absolute;top:0}._2PiyJ,._2wxFf{font-size:18px;line-height:30px;margin:0 0 20px}._2wxFf{visibility:hidden}", ""]);
// Exports
exports.locals = {
	"valueTitle": "_3n7Iq",
	"relativeContainer": "CYWBC",
	"description": "_2PiyJ",
	"hiddenDescription": "_2wxFf"
};
module.exports = exports;
